import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import {
    Switch,
    BrowserRouter as Router,
    Route,
    BrowserRouter,
} from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap/dist/js/bootstrap.js";
import Main from "./componentes/Main";
import Deshabilitar from "./componentes/deshabilitar";
import ImportarExcel from "./componentes/importar-excel";
import MainAuth from "./componentes/MainAuth";
import Login from "./componentes/Login";
import ForgotPassword from "./componentes/ForgotPassword";
import * as FilePond from "filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "./index.css";
import Amplify from "aws-amplify";
import Perfil from "./componentes/Perfil";
import Reporte from "./componentes/Reporte";
import getTheme from "./config/theme";

// Initialize theme CSS variables
const theme = getTheme();
document.documentElement.style.setProperty('--primary-color', theme.primaryColor);
document.documentElement.style.setProperty('--secondary-color', theme.secondaryColor);
document.documentElement.style.setProperty('--accent-color', theme.accentColor);
document.documentElement.style.setProperty('--logo-text-color', theme.logoTextColor);
document.documentElement.style.setProperty('--navbar-text-color', theme.navbarTextColor);

Amplify.configure({
    Auth: {
        region: process.env.REACT_APP_AMPLIFY_REGION,
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
        authenticationFlowType: "USER_PASSWORD_AUTH",
    },
});

FilePond.registerPlugin(FilePondPluginFileValidateType);

ReactDOM.render(
    <BrowserRouter>
        <Router>
            <Switch>
                <Route exact path={["/", "/deshabilitar"]}>
                    <Main>
                        <Deshabilitar key={Math.random()} accion="DES" />
                    </Main>
                </Route>
                <Route exact path="/habilitar">
                    <Main>
                        <Deshabilitar key={Math.random()} accion="HAB" />
                    </Main>
                </Route>
                <Route exact path="/cargar-excel">
                    <Main>
                        <ImportarExcel key={Math.random()} />
                    </Main>
                </Route>
                <Route exact path="/perfil">
                    <Main>
                        <Perfil />
                    </Main>
                </Route>
                <Route exact path="/reporte">
                    <Main>
                        <Reporte key={Math.random()} />
                    </Main>
                </Route>
                <Route exact path="/login">
                    <MainAuth>
                        <Login />
                    </MainAuth>
                </Route>
                <Route exact path="/recover-account">
                    <MainAuth>
                        <ForgotPassword />
                    </MainAuth>
                </Route>
            </Switch>
        </Router>
    </BrowserRouter>,
    document.getElementById("root")
);

reportWebVitals();
